import React, { FunctionComponent } from "react";
import { Tooltip } from "antd";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { V2Question } from "../helper";
import styles from "./TabularForm.module.scss";

// Treat rich-text descriptions as absent unless there's real text once tags are stripped.
const hasDescription = (description?: string | null): boolean => !!description && description.replace(/<[^>]*>/g, "").trim().length > 0;

// Question header cell: title clamps to two lines; hover shows the description (dotted underline hints at it).
const QuestionHeaderCell: FunctionComponent<{ question: V2Question }> = ({ question }) => {
  const showDescription = hasDescription(question.description);

  const title = (
    <div className={`${styles.questionTitle} ${showDescription ? styles.hasDescription : ""}`}>
      {question.label}
      {question.isRequired ? <span className={styles.requiredMark}>*</span> : null}
    </div>
  );

  if (!showDescription) return title;

  return (
    <Tooltip
      title={
        <div className={styles.descriptionTooltip}>
          <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
            {question.description as string}
          </ReactMarkdown>
        </div>
      }
    >
      {title}
    </Tooltip>
  );
};

export default QuestionHeaderCell;
